<template>
  <label
    :class="[
      'giving-method-card',
      {
        'giving-method-card--selected': isSelected,
      },
    ]"
    @click="handleClick"
  >
    <div class="giving-method-card__content">
      <img :src="iconPath" :alt="label" class="giving-method-card__icon" />
      <div class="giving-method-card__label">{{ label }}</div>
    </div>
    <div class="giving-method-card__radio">
      <div v-if="isSelected" class="giving-method-card__radio-dot"></div>
    </div>
    <input
      type="radio"
      :name="name"
      :value="value"
      :checked="isSelected"
      class="giving-method-card__input"
      @change="handleChange"
    />
  </label>
</template>

<script>
export default {
  name: 'GivingMethodCard',
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    modelValue: {
      type: [String, Number],
      default: null,
    },
    name: {
      type: String,
      default: 'radio-group',
    },
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    iconPath() {
      return `/assets/icons/my-giving/${this.icon}.png`;
    },
    isSelected() {
      return this.modelValue === this.value;
    },
  },
  methods: {
    handleClick() {
      if (!this.isSelected) {
        this.$emit('update:modelValue', this.value);
        this.$emit('change', this.value);
      }
    },
    handleChange(event) {
      if (event.target.checked) {
        this.$emit('update:modelValue', this.value);
        this.$emit('change', this.value);
      }
    },
  },
};
</script>

<style scoped>
.giving-method-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 56px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: transparent;
  border: 1px solid #a5a4a3;
  border-radius: 10px;
  cursor: pointer;
  gap: 16px;
  font-family: 'Inter', sans-serif;
  transition:
    background-color 0.2s,
    border-color 0.2s,
    border-width 0.2s;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  .giving-method-card {
    min-height: 64px;
    padding-top: 18px;
    padding-bottom: 18px;
    padding-left: 24px;
    padding-right: 24px;
    gap: 18px;
  }
}

@media (min-width: 1024px) {
  .giving-method-card {
    min-height: 72px;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 28px;
    padding-right: 28px;
    gap: 20px;
  }
}

.giving-method-card--selected {
  background-color: rgba(232, 220, 199, 0.4);
  border: 2px solid #42362b;
}

.giving-method-card__content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1 0;
  min-width: 0;
}

@media (min-width: 768px) {
  .giving-method-card__content {
    gap: 18px;
  }
}

@media (min-width: 1024px) {
  .giving-method-card__content {
    gap: 20px;
  }
}

.giving-method-card__icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  object-fit: contain;
}

@media (min-width: 768px) {
  .giving-method-card__icon {
    width: 32px;
    height: 32px;
  }
}

@media (min-width: 1024px) {
  .giving-method-card__icon {
    width: 40px;
    height: 40px;
  }
}

.giving-method-card__label {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #21201e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 0;
  min-width: 0;
}

@media (min-width: 768px) {
  .giving-method-card__label {
    font-size: 28px;
    line-height: 36px;
  }
}

@media (min-width: 1024px) {
  .giving-method-card__label {
    font-size: 30px;
    line-height: 40px;
  }
}

.giving-method-card__radio {
  position: relative;
  width: 16px;
  height: 16px;
  border: 1px solid #42362b;
  border-radius: 50%;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .giving-method-card__radio {
    width: 20px;
    height: 20px;
  }
}

@media (min-width: 1024px) {
  .giving-method-card__radio {
    width: 24px;
    height: 24px;
  }
}

.giving-method-card__radio-dot {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 6.4px;
  height: 6.4px;
  background-color: #42362b;
  border-radius: 50%;
}

@media (min-width: 768px) {
  .giving-method-card__radio-dot {
    width: 8px;
    height: 8px;
  }
}

@media (min-width: 1024px) {
  .giving-method-card__radio-dot {
    width: 9.6px;
    height: 9.6px;
  }
}

.giving-method-card__input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
}
</style>
